export default "__VITE_ASSET__DpXsFYxa__"